import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Icon, Select, Button, Grid, Input} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {partClassification} from '../../../common/dictionaries/classification';
import {months} from '../../../common/constants/months';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import TableRecords from './table';
import './kardex.scss';

const date = new Date();
const currentYear = date.getFullYear();
const currentMonth = date.getMonth();

class Kardex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showPartInfo': props.areTheParametersInUrl ? true : false,
      'partCodeSelected': '',
      'warehouseTmp': '',
      'warehouseSelected': '',
      'monthTmp': currentMonth + 1,
      'monthSelected': currentMonth + 1,
      'yearTmp': currentYear,
      'yearSelected': currentYear,
    };
    this.getKardex = this.getKardex.bind(this);
    this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
    const {permissions, code, areTheParametersInUrl} = this.props;
    if (!hasAccessPermission(permissions, resources.Kardex, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    this.props.clearFilters();
    if (areTheParametersInUrl) {
      this.props.fetchPart(code);
      this.onSearch(0);
      return;
    }
    this.props.fetchWarehouses();
  }

  onCancelClick() {
    this.props.goBack();
  }

  onDownloadClick() {
    const {areTheParametersInUrl, code, warehouse} = this.props;
    const {partCodeSelected, warehouseSelected, monthSelected, yearSelected} =
      this.state;

    if (areTheParametersInUrl) {
      this.props.downloadKardex(code, warehouse, {'month': monthSelected, 'year': yearSelected});
      return;
    }
    this.props.downloadKardex(partCodeSelected, warehouseSelected, {'month': monthSelected, 'year': yearSelected});
  }

  renderTitle(title) {
    const {areTheParametersInUrl} = this.props;
    if (areTheParametersInUrl) {
      return;
    }
    return (
      <Grid.Column textAlign='right'>
        <h4>{title}</h4>
      </Grid.Column>
    );
  }

  onChangeTemporalValues(value, field) {
    const {showPartInfo} = this.state;
    const key = field === 'partCode' ? 'partCodeSelected' : `${field}Tmp`;
    const valueFormatted =
      value && field === 'partCode' ? value.toUpperCase() : value;

    const newState = {[key]: valueFormatted};
    if (field === 'partCode' && showPartInfo) {
      newState.showPartInfo = false;
      this.props.clearFilters();
    }
    this.setState(newState, () => this.updateDataSelected(field));
  }

  updateDataSelected(field) {
    const temporalValue = this.state[`${field}Tmp`];
    const selectedValue = this.state[`${field}Selected`];

    if (field === 'partCode' || selectedValue === temporalValue) {
      return;
    }
    const {monthSelected} = this.state;
    const newState = {[`${field}Selected`]: temporalValue};
  
    if (
      field === 'year' &&
      temporalValue === currentYear &&
      monthSelected > currentMonth + 1
    ) {
      newState.monthTmp = currentMonth + 1;
      newState.monthSelected = currentMonth + 1;
    }
    this.setState(newState);
    this.props.clearFilters();
  }

  getWarehouses() {
    const {permissions, warehousesList} = this.props;
    const warehousesAllowed = [];
    warehousesList.forEach((element) => {
      if (hasAccessPermission(permissions, `Bodega ${element.code}`, scopes.KardexSee)) {
        warehousesAllowed.push({'text': element.code, 'value': element.code});
      }
    });
    return warehousesAllowed;
  }

  getMonths() {
    return Object.keys(months).map((month) => {
      const monthDisabled =
        currentYear === this.state.yearSelected &&
        months[month] > currentMonth + 1;
      return {'text': month, 'value': months[month], 'disabled': monthDisabled};
    });
  }

  getYears() {
    const years = [];
    const initialYear = 2015;
    const numberOfYears = currentYear - initialYear;
    for (let i = 0; i <= numberOfYears; i++) {
      years.push(initialYear + i);
    }
    return Object.keys(years).map((position) => {
      const year = years[position];
      return {'text': year, 'value': year};
    });
  }

  getKardex(pageNumber, pageSize) {
    const {code, warehouse, areTheParametersInUrl} = this.props;
    const {partCodeSelected, warehouseSelected, monthSelected, yearSelected} =
      this.state;
    if (!areTheParametersInUrl) {
      this.props.fetchPart(partCodeSelected);
    }
    this.props.fetchKardex({
      'code': code || partCodeSelected,
      'warehouse': warehouse || warehouseSelected,
      'month': monthSelected,
      'year': yearSelected,
    }, pageSize, pageNumber);
  }

  onSearch(value) {
    const {pageSize} = this.props;
    this.setState({'showPartInfo': true}, () => this.getKardex(value, pageSize));
  }

  renderDownloadIcon() {
    const {loading, downloading, areTheParametersInUrl} = this.props;
    const {partCodeSelected, warehouseSelected} = this.state;
    const isEnabledDownload = areTheParametersInUrl ? true :
      partCodeSelected !== '' && warehouseSelected !== '';
    return (
      <Button
        type='button'
        primary
        className='toyota-primary download'
        disabled={loading || downloading || !isEnabledDownload}
        loading={downloading}
        onClick={this.onDownloadClick.bind(this)}
      >
        <Icon name='download' />
        Excel
      </Button>
    );
  }

  renderSubtitle() {
    const {partData} = this.props;
    const {showPartInfo} = this.state;
    if (!showPartInfo) {
      return null;
    }
    return `${partData.franchise} | ${partData.code} | ${
      partClassification[partData.classification || 'R']
    } | ${partData.name} | ${partData.origin || ''}`;
  }

  render() {
    const {loading, balanceInfo, downloading, warehouse, areTheParametersInUrl} = this.props;
    const {partCodeSelected, warehouseTmp, warehouseSelected, monthTmp, yearTmp} = this.state;
    const isEnabledDownload = areTheParametersInUrl ?
      true :
      partCodeSelected !== '' && warehouseSelected !== '';
    return (
      <div className='view-kardex'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              {areTheParametersInUrl && (
                <Icon
                  name='arrow left'
                  onClick={this.onCancelClick.bind(this)}
                />
              )}
              <h2>
                KARDEX {areTheParametersInUrl ? ` | Bodega ${warehouse} ` : ''}
              </h2>
              <div className='title-bar-actions'>
                <Button
                  primary
                  type='submit'
                  className='toyota-primary'
                  disabled={!isEnabledDownload || loading || downloading}
                  onClick={this.onSearch.bind(this, 0)}
                >
                  Consultar
                </Button>
                {this.renderDownloadIcon()}
              </div>
            </div>
            <div className='subtitle'>{this.renderSubtitle()}</div>
            <div className='filters-section'>
              <Grid>
                <Grid.Row textAlign='left'>
                  <Grid.Column width={2}>
                    <h4>Saldo Inicial</h4>
                    <h4>Saldo Final</h4>
                  </Grid.Column>
                  <Grid.Column width={areTheParametersInUrl ? 6 : 1}>
                    <div>{balanceInfo.initialBalance}</div>
                    <div>{balanceInfo.finalBalance}</div>
                  </Grid.Column>
                  {this.renderTitle('Código')}
                  {!areTheParametersInUrl && (
                    <Grid.Column width={2}>
                      <Input
                        placeholder='Código Parte'
                        value={partCodeSelected}
                        disabled={loading || downloading}
                        onChange={(e, {value}) =>
                          this.onChangeTemporalValues(value, 'partCode')
                        }
                      />
                    </Grid.Column>
                  )}
                  {this.renderTitle('Bodega')}
                  {!areTheParametersInUrl && (
                    <Grid.Column width={2}>
                      <Select
                        className='warehouse'
                        placeholder='Bodega'
                        options={this.getWarehouses()}
                        value={warehouseTmp}
                        disabled={loading || downloading}
                        onChange={(e, {value}) =>
                          this.onChangeTemporalValues(value, 'warehouse')
                        }
                      />
                    </Grid.Column>
                  )}
                  <Grid.Column textAlign='right'>
                    <h4>Mes desde</h4>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Select
                      placeholder='Seleccione un Mes'
                      options={this.getMonths()}
                      value={monthTmp}
                      disabled={loading || downloading}
                      onChange={(e, {value}) =>
                        this.onChangeTemporalValues(value, 'month')
                      }
                    />
                  </Grid.Column>
                  <Grid.Column textAlign='right'>
                    <h4>Año</h4>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <Select
                      placeholder='Seleccione un año'
                      options={this.getYears()}
                      value={yearTmp}
                      disabled={loading || downloading}
                      onChange={(e, {value}) =>
                        this.onChangeTemporalValues(value, 'year')
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        <Card fluid raised className='kardex-container'>
          <TableRecords getKardex={this.getKardex} onSearch={this.onSearch} />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {code, warehouse} = ownProps.params;
  const areTheParametersInUrl = code && warehouse;
  return {
    code,
    warehouse,
    areTheParametersInUrl,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
    'partData': state.kardex.partData,
    'loading': state.kardex.loading,
    'pageSize': state.kardex.pageSize,
    'balanceInfo': state.kardex.balanceInfo,
    'downloading': state.kardex.downloading,
    'permissions': state.session.permissions,
    'warehousesList': state.warehouses.list,
  };
};

const {fetchPart, fetchKardex, downloadKardex, clearFilters, fetchWarehouses, withRouter} =
  Actions;

export default withRouter(connect(mapStateToProps, {
  fetchPart,
  fetchKardex,
  downloadKardex,
  fetchWarehouses,
  clearFilters,
})(Kardex));
